import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ChangingRoom = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="changing-room"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23.8111 16.6818L13.4735 10.2072V9.72085C13.4735 9.43353 13.6209 9.20198 13.9376 8.99319C13.9766 8.96717 14.0227 8.93925 14.0738 8.90808C14.576 8.60028 15.6212 7.96002 15.6212 6.51678C15.6212 5.0177 14.3858 3.86738 13.1908 3.62096C11.9326 3.35966 10.7917 3.66604 10.0486 4.48161C9.37117 5.22277 9.18098 5.84026 9.14099 6.84271C9.13773 6.91524 9.1359 7.07146 9.13402 7.22396C9.13213 7.43457 9.54781 7.60572 10.0611 7.60572H10.2471C10.7604 7.60572 11.1775 7.43554 11.1784 7.22493C11.1789 7.05104 11.1803 6.87623 11.1817 6.84317C11.2101 6.15178 11.396 5.7449 12.1018 5.60219C12.5408 5.51387 13.0146 5.63662 13.2921 5.90861C13.4182 6.03137 13.4846 6.24433 13.466 6.46427C13.454 6.61076 13.3912 6.88504 13.1145 7.07569L12.2288 7.67876C11.6639 8.04051 11.4234 8.47341 11.4234 9.12573V10.2086L1.19013 16.659C-0.326622 17.5945 -0.0127583 19.1898 0.119777 19.6567C0.241158 20.0821 0.793036 21.47 2.80263 21.47H22.3251C23.7451 21.47 24.6434 20.5466 24.9052 19.6306C25.1762 18.6728 24.8824 17.3132 23.8111 16.6818ZM22.7607 18.935C22.7119 19.1061 22.5534 19.2907 22.2957 19.2907H2.77798C2.50736 19.2898 2.35486 19.1122 2.30653 18.9606C2.24469 18.7658 2.32466 18.5668 2.50879 18.4361L12.512 12.1749L22.5706 18.4626C22.8194 18.6184 22.7864 18.8448 22.7607 18.935Z" />
    </svg>
  );
};
/* eslint-enable max-len */

ChangingRoom.defaultProps = {
  className: null,
};

ChangingRoom.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ChangingRoom;
